var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClinic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 23,
    fill: "#4B9BF5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6011 19.0307H30.8594C31.9047 19.0307 32.752 19.878 32.752 20.9233V24.7084C32.752 25.7537 31.9047 26.601 30.8594 26.601H26.6011V30.8593C26.6011 31.9046 25.7538 32.7519 24.7085 32.7519H20.9234C19.8782 32.7519 19.0308 31.9046 19.0308 30.8593V26.601H14.7726C13.7273 26.601 12.88 25.7537 12.88 24.7084V20.9233C12.88 19.878 13.7273 19.0307 14.7726 19.0307H19.0308V14.7725C19.0308 13.7272 19.8782 12.8799 20.9234 12.8799H24.7085C25.7538 12.8799 26.6011 13.7272 26.6011 14.7725V19.0307ZM24.7085 19.977V14.7725H20.9234V19.977C20.9234 20.4996 20.4997 20.9233 19.9771 20.9233H14.7726V24.7084H19.9771C20.4997 24.7084 20.9234 25.1321 20.9234 25.6547V30.8593H24.7085V25.6547C24.7085 25.1321 25.1322 24.7084 25.6548 24.7084H30.8594V20.9233H25.6548C25.1322 20.9233 24.7085 20.4996 24.7085 19.977Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinic);
export default __webpack_public_path__ + "static/media/clinic.7a8a48c1f691550cd38e374e20fa6603.svg";
export { ForwardRef as ReactComponent };